export default __webpack_public_path__ + "static/media/WhitePosLogo.e64d0d4f.svg";